<app-cms-top-bar></app-cms-top-bar>
<div id="wrapper">
    <app-cms-side-bar [active]="'cms-home'"></app-cms-side-bar>
    <div id="content-wrapper">
        <div class="container-fluid">
            <p class="title">Home</p>
            <div class="card mb-3">
                <div class="card-body p-3">
                    <div class="table-responsive" style="overflow-x: hidden;">
                        <H1 >Hello CMS HOME.</H1>
                    </div>
                </div>
            </div>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>